export default "__VITE_ASSET__CzmokN3S__"